module.exports = __webpack_public_path__ + "files/1c85ced3691498e60fedebeb0830226a.png";